import {
  ColocaAmountDisplay,
  type ColocaAmountDisplayProps,
} from "@/shared/components/data-display/ColocaAmountDisplay";

import { amountPrecision, type PairPrecision } from "../../utils/cryptoSwapFormat";

export interface AssetAmountProps extends Omit<
  ColocaAmountDisplayProps,
  "value" | "currency" | "fractionDigits" | "minimumFractionDigits" | "maximumFractionDigits"
> {
  value: string;
  /** Picks the precision only; the code itself is rendered by the caller. */
  currency: string;
  pair?: PairPrecision | null;
}

/** An amount at its currency's precision: whole pesos, USDT to the pair's decimals, never 8 digits. */
export function AssetAmount({ value, currency, pair, ...rest }: AssetAmountProps) {
  const precision = amountPrecision(currency, pair);
  return (
    <ColocaAmountDisplay
      value={value}
      minimumFractionDigits={precision.min}
      maximumFractionDigits={precision.max}
      {...rest}
    />
  );
}
